export const FETCH_SUCCESS = "AREAS/FETCH_SUCCESS";
export const TABLE_UPDATE = "AREAS/TABLE_UPDATE";

const types = {
    DESTROY_FAILED: "AREAS/DESTROY_FAILED",
    DESTROY_REQUEST: "AREAS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "AREAS/DESTROY_SUCCESS",

    FETCH_FAILED: "AREAS/FETCH_FAILED",
    FETCH_REQUEST: "AREAS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "AREAS/GET_FAILED",
    GET_REQUEST: "AREAS/GET_REQUEST",
    GET_SUCCESS: "AREAS/GET_SUCCESS",

    STORE_FAILED: "AREAS/STORE_FAILED",
    STORE_REQUEST: "AREAS/STORE_REQUEST",
    STORE_SUCCESS: "AREAS/STORE_SUCCESS",

    UPDATE_FAILED: "AREAS/UPDATE_FAILED",
    UPDATE_REQUEST: "AREAS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "AREAS/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
